import script from "./BuyFast.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyFast.vue?vue&type=script&setup=true&lang=js"

import "./BuyFast.vue?vue&type=style&index=0&id=a4ef012e&scoped=true&lang=less"
import "./BuyFast.vue?vue&type=style&index=1&id=a4ef012e&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4ef012e"]])

export default __exports__